<template>
  <el-card :class="['box-card', extension.status]">
      <div class='card-top row gx-4'>
          <div class="card-top-info">
              <p class="card-top-info-content name">{{ name }}</p>
              <p class="card-top-info-content">{{ extension.extension }}</p>
          </div>
      </div>

    <div class='card-middle'>
      <div class='row row-center'>
        <p>
            <i class="fas fa-phone" :class="[extension.status, {'fa-bounce': isRinging}]"></i>
        </p>
      </div>
    </div>
    <p class="card-bottom" v-if="extension.fakeDestiny">Atendido en {{ extension.fakeDestiny }}</p>
    <!-- <div class="card-bottom">
      <p>{{ $t(`extensionStatus.${extension.status}`) }}</p>
    </div> -->
  </el-card>
</template>

<script>
export default {
name: "TheExtensionCard",
props: {
  ellipsis:{
      required: false,
      default: false
  },
  extension : {
      required : true,
      default : () => {
          return {
              extension : 0,
              name : '',
              status : '',
              fakeDestiny: ''
          }
      }
  }
},
computed:{
  isRinging(){
    return this.extension.status === 'ringing'
  },
  name(){
    if(this.extension.name && this.extension.name.length > 14){
      return this.extension.name.slice(0,13) + '...'
    }
    return this.extension.name
  }
},
mounted(){
}
};
</script>
<style scoped>
.hide{
  display: none;
}

.ellipsis{
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
}

.card-top-info-content {
  font-weight: bold;
  margin-bottom: 0;
}
.card-top-info-content.name{
  max-width: 7rem;
  overflow: hidden;
  line-height: 15px;
  margin-bottom: 0;
}
.el-card__body{
padding: 0 !important;
}

.box-card .el-card__body{
  display: flex;
  flex-direction: column;
  align-items: center;
}
/* CARDS */
.box-card{
font-size: 0.84rem;
width: 150px;
height: 130px;
}
.box-card{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.box-card .row{
  margin-left: 0;
  margin-right: 0;
}

.box-card .card-top{
  margin-bottom: .1em;
  flex-wrap: nowrap;
}

.box-card .card-top-info{
flex: 1;
overflow: hidden;
text-align: center;
}

.box-card .card-top p.icon{
  margin: 0;
}
.box-card .card-middle{
justify-content: center;
}

.box-card .card-middle .row-center{
text-align: center;
display: flex;
justify-content: center;
}

.box-card .card-middle div p{
display: flex;
flex-direction: column;
align-items: center;
margin: .3em 0 0;
}

.box-card .card-middle i{
font-size: 28px;
line-height: 28px;
margin: 0 0 .1em 0;
padding :0;
}

.box-card .card-bottom{
  text-align: center;
  font-weight: bold;
  font-size: .8rem;
  margin-top: .4em;
}

.box-card.inuse{
  background: rgba(138,204,64, 0.1);
}
.box-card.idle{
  background: rgba(0,0,0, 0.1);
}
.box-card.unavailable{
  background: rgba(245, 108, 108, 0.1);
}
.box-card.ringing{
  background: rgba(64, 158, 255, 0.1);
}
.box-card.hold{
  background: rgba(238, 255, 90, 0.1);
}

/* FONT AWESOME */
.icon{
  color: var(--grey-status);
}

.fa, .fal, .far {
  display: inline-block;
}

/* COLOR TELEFONO ICONO */

.fa-phone{
  color: var(--green);
}
.fa-phone.unavailable {
  color: var(--danger);
}
.fa-phone.inuse{
  color: var(--green);
}
.fa-phone.idle{
  color: var(--grey-neutral-900);
}
.fa-phone.hold{
  color: #FFC300
}
.fa-phone.ringing {
  color: var(--blue);
  animation: shake-rotate 2s linear 1ms infinite normal forwards;
}


/* ICONOS EXTRA */

.hm-icon::before{
  content: "";
  display: inline-block;
  height: 1em;
  width: 1em;
  background-size: contain;
}

.hm-outgoing::before{
  background-image: url('data:image/svg+xml;base64,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');
}

.hm-incoming::before{
  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgMjU2IDI1NiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+Cgo8ZGVmcz4KPC9kZWZzPgo8ZyBzdHlsZT0ic3Ryb2tlOiBub25lOyBzdHJva2Utd2lkdGg6IDA7IHN0cm9rZS1kYXNoYXJyYXk6IG5vbmU7IHN0cm9rZS1saW5lY2FwOiBidXR0OyBzdHJva2UtbGluZWpvaW46IG1pdGVyOyBzdHJva2UtbWl0ZXJsaW1pdDogMTA7IGZpbGw6IG5vbmU7IGZpbGwtcnVsZTogbm9uemVybzsgb3BhY2l0eTogMTsiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuNDA2NTkzNDA2NTkzNDAxNiAxLjQwNjU5MzQwNjU5MzQwMTYpIHNjYWxlKDIuODEgMi44MSkiID4KCTxwYXRoIGQ9Ik0gMzguNzg5IDUxLjIxMSBsIDEwLjg3NiAxMC44NzYgYyAwLjk3NCAwLjk3NCAyLjQ3MSAxLjE5NCAzLjY4NCAwLjU0MyBsIDEzLjAzNCAtNi45OTcgYyAwLjk2NCAtMC41MTggMi4xMjkgLTAuNDkzIDMuMDcgMC4wNjYgbCAxOS4wMTcgMTEuMjg1IGMgMS4zNTcgMC44MDUgMS45MDMgMi40ODkgMS4yNjggMy45MzMgYyAtMS42MjUgMy42OTggLTQuNTgzIDEwLjQ3NiAtNS43NTggMTMuNDczIGMgLTAuMjQ3IDAuNjMxIC0wLjYxNSAxLjIwOSAtMS4xMjcgMS42NTIgYyAtMTIuNjc0IDEwLjk4NiAtMzcuODkgLTIuNCAtNTcuMTkxIC0yMS43MDEgQyA2LjM1OCA0NS4wMzkgLTcuMDI4IDE5LjgyMyAzLjk1OCA3LjE0OSBjIDAuNDQ0IC0wLjUxMiAxLjAyMiAtMC44OCAxLjY1MiAtMS4xMjcgYyAyLjk5NiAtMS4xNzUgOS43NzUgLTQuMTMzIDEzLjQ3MyAtNS43NTggYyAxLjQ0NCAtMC42MzUgMy4xMjggLTAuMDg5IDMuOTMzIDEuMjY4IGwgMTEuMjg1IDE5LjAxNyBjIDAuNTU4IDAuOTQxIDAuNTgzIDIuMTA2IDAuMDY2IDMuMDcgTCAyNy4zNyAzNi42NTEgYyAtMC42NTEgMS4yMTMgLTAuNDMxIDIuNzEgMC41NDMgMy42ODQgQyAyNy45MTMgNDAuMzM1IDM4Ljc4OSA1MS4yMTEgMzguNzg5IDUxLjIxMSB6IiBzdHlsZT0ic3Ryb2tlOiBub25lOyBzdHJva2Utd2lkdGg6IDE7IHN0cm9rZS1kYXNoYXJyYXk6IG5vbmU7IHN0cm9rZS1saW5lY2FwOiBidXR0OyBzdHJva2UtbGluZWpvaW46IG1pdGVyOyBzdHJva2UtbWl0ZXJsaW1pdDogMTA7IGZpbGw6IHJnYigxMzgsMjA0LDYzKTsgZmlsbC1ydWxlOiBub256ZXJvOyBvcGFjaXR5OiAxOyIgdHJhbnNmb3JtPSIgbWF0cml4KDEgMCAwIDEgMCAwKSAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KCTxwYXRoIGQ9Ik0gNzYuNDA4IDAuNDcxIEwgNjMuMDMyIDEzLjg0NyBsIC01LjEzNCAtNS4xMzQgYyAtMC44NDMgLTAuODQzIC0yLjI4NCAtMC40NTggLTIuNTkyIDAuNjk1IGwgLTguNTYxIDMxLjk1IGMgLTAuMzA5IDEuMTUyIDAuNzQ2IDIuMjA2IDEuODk4IDEuODk4IGwgMzEuOTUgLTguNTYxIGMgMS4xNTIgLTAuMzA5IDEuNTM4IC0xLjc0OSAwLjY5NSAtMi41OTIgbCAtNS4xMzQgLTUuMTM0IGwgMTMuMzc2IC0xMy4zNzYgYyAwLjYyOCAtMC42MjggMC42MjggLTEuNjQ2IDAgLTIuMjc0IEwgNzguNjgyIDAuNDcxIEMgNzguMDU0IC0wLjE1NyA3Ny4wMzYgLTAuMTU3IDc2LjQwOCAwLjQ3MSB6IiBzdHlsZT0ic3Ryb2tlOiBub25lOyBzdHJva2Utd2lkdGg6IDE7IHN0cm9rZS1kYXNoYXJyYXk6IG5vbmU7IHN0cm9rZS1saW5lY2FwOiBidXR0OyBzdHJva2UtbGluZWpvaW46IG1pdGVyOyBzdHJva2UtbWl0ZXJsaW1pdDogMTA7IGZpbGw6IHJnYigxMzgsMjA0LDYzKTsgZmlsbC1ydWxlOiBub256ZXJvOyBvcGFjaXR5OiAxOyIgdHJhbnNmb3JtPSIgbWF0cml4KDEgMCAwIDEgMCAwKSAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KPC9nPgo8L3N2Zz4=');
}

:deep( .timer ){
font-size: 0.8em !important
}
:deep( .chronometer ){
font-size: 1em !important;
}

/*EFFECCTS*/

@keyframes shake-rotate {
	0%,
	100% {
		transform: translateY(0);
	}

	10%,
	30%,
	50%,
	70% {
		transform: translateY(-8px);
	}

	20%,
	40%,
	60% {
		transform: translateY(8px);
	}

	80% {
		transform: translateY(6.4px);
	}

	90% {
		transform: translateY(-6.4px);
	}
}
</style>